import React from 'react'

import { ColumnLayout } from '@/components'
import { useGetViewerQuery } from '@/generated/graphql'

import { BasicProfile } from './basic-part/basic-profile-part.component'
import { WorkExperience } from './career-part/career-profile-part.component'
import { CompanyProfile } from './company-part/company-profile-part.component'
import { ProfileSideBar } from './profile-sidebar/profile.sidebar'
import s from './profile.module.less'

export const ProfileContainer: React.FC<{ userId: number }> = ({ userId }) => {
  const viewer = useGetViewerQuery()
  const [editSet, setEditSet] = React.useState<Set<string>>(new Set())
  const isViewer = userId === viewer.data?.viewer.userId

  if (!viewer) {
    return null
  }

  const middle = (
    <div className={s.profileMiddle}>
      <CompanyProfile
        userId={userId}
        isViewer={isViewer}
        isEdit={editSet.has('company')}
        onEdit={(isEdit: boolean) => {
          const newSet = new Set(editSet)
          if (isEdit) {
            newSet.add('company')
            setEditSet(newSet)
          } else {
            newSet.delete('company')
            setEditSet(newSet)
          }
        }}
      />
      <WorkExperience
        userId={userId}
        isViewer={isViewer}
        isEdit={editSet.has('career')}
        onEdit={(isEdit: boolean) => {
          const newSet = new Set(editSet)
          if (isEdit) {
            newSet.add('career')
            setEditSet(newSet)
          } else {
            newSet.delete('career')
            setEditSet(newSet)
          }
        }}
      />
    </div>
  )

  const sidebar = (
    <>
      <BasicProfile
        userId={userId}
        isViewer={isViewer}
        isEdit={editSet.has('basic')}
        onEdit={(isEdit: boolean) => {
          const newSet = new Set(editSet)
          if (isEdit) {
            newSet.add('basic')
            setEditSet(newSet)
          } else {
            newSet.delete('basic')
            setEditSet(newSet)
          }
        }}
      />
      <ProfileSideBar
        userId={userId}
        isViewer={isViewer}
        isEdit={editSet.has('sidebar')}
        onEdit={(isEdit: boolean) => {
          const newSet = new Set(editSet)
          if (isEdit) {
            newSet.add('sidebar')
            setEditSet(newSet)
          } else {
            newSet.delete('sidebar')
            setEditSet(newSet)
          }
        }}
      />
    </>
  )

  return (
    <div className={s.profileContainer}>
      <ColumnLayout middle={middle} right={sidebar} />
    </div>
  )
}
